import { GetSearchApiResponse } from '@finance-lab/utils/types'
import ApiBase from './Api'

const SEARCH_API_PATHS = {
    SEARCH: '/search',
}

class SearchApi extends ApiBase {
    async freeSearch(query: string) {
        const response = await this._getRequest<GetSearchApiResponse>(SEARCH_API_PATHS.SEARCH, {
            queryParameters: { q: query },
        })

        return response
    }
}

export default SearchApi
